import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { fetchRewardsGroups, createRewardsGroup, updateRewardsGroup, fetchAllRewardGroups } from '@/api/rewards-group'
import { useAuthQuery } from '@/hooks/use-auth-query'

export const useFetchRewardsGroups = (page = 1) => {
  return useAuthQuery({
    queryKey: ['rewardsGroups', page],
    queryFn: () => fetchRewardsGroups(page),
    keepPreviousData: true,
    onError: error => {
      console.error('Error fetching rewards groups:', error.message)
    },
  })
}

export const useFetchAllRewardsGroups = () => {
  return useQuery({
    queryKey: ['allRewardsGroups'],
    queryFn: () => fetchAllRewardGroups(),
    onError: error => {
      console.error('Error fetching all rewards groups:', error.message)
    },
    staleTime: Infinity,
  })
}

export function useCreateGroup() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['createGroup'],
    mutationFn: createRewardsGroup,
    onMutate: async newGroupData => {
      const previousGroups = queryClient.getQueryData(['groupData'])
      queryClient.setQueryData(['groupData'], (current = []) => [...current, newGroupData])
      return { previousGroups }
    },
    onError: context => {
      queryClient.setQueryData(['groupData'], context.previousGroups)
    },
    onSettled: () => {
      queryClient.invalidateQueries(['groupData'])
    },
  })
}

// Hook to update an existing rewards group

export const useUpdateRewardsGroup = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ ruleGroup, updateData }) => {
      const response = await updateRewardsGroup({ ruleGroup, updateData })
      return response
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['rewardsGroups']) // Invalidate to refetch the list
    },
  })
}
